module.exports = __webpack_public_path__ + "static/media/bingo-ball_01.2c852345.png";